import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { INSURER_FULL_NAME, INSURER_CODE } from "src/app/share/constants/common.info";
import { ProductDocumentInterface } from "src/app/share/interface/motor.interface";

@Component({
  selector: "app-acknowledgement",
  templateUrl: "./acknowledgement.component.html",
  styleUrls: ["./acknowledgement.component.scss"],
})

export class AcknowledgementComponent implements OnInit {
    isShowTreatmentOfSmallAmount: boolean = false;
    treatmentOfSmallAmountTitle: string = "";
    treatmentOfSmallAmountDesc: string = "";

    params: any;
    isAgree: boolean = false;
    declarationList: any[];
    declarationCheckboxController = [
        {
            checkbox: "isRead",
            checked: false,
            acknowledgement: "common.acknowledgementConfirmationOne"
        },
        { 
            checkbox: "isConfirm",
            checked: false,
            acknowledgement: "common.acknowledgementConfirmationTwo"
        },
        { 
            checkbox: "isDirectMarketing",
            checked: false,
            acknowledgement: "common.acknowledgementConfirmationThree"
        }
    ];
    motorProductDoc: any;

    constructor(
        public translate: TranslateService,
        @Inject(MAT_DIALOG_DATA) public data: {
			selectedQuotation: any,
            productDocument: ProductDocumentInterface[]
		}
    ) {}

    ngOnInit() {
        this.motorProductDoc = {
            productDisclosureSheet: this.data.productDocument.find(x => x.code == "productDisclosureSheet")?.url,
            dutyOfDisclosure: this.data.productDocument.find(x => x.code == "dutyOfDisclosure")?.url,
            policyWording: this.data.productDocument.find(x => x.code == "policyWording")?.url,
            privacyNotice: this.data.productDocument.find(x => x.code == "privacyNotice")?.url,
        };

        this.loadInsurerDeclarationList();
    }

    onDeclarationCheckboxChange(item: any): void {
        item.checked = !item.checked;

        if (this.declarationCheckboxController.find(x => x.checkbox == "isRead").checked &&
            this.declarationCheckboxController.find(x => x.checkbox == "isConfirm").checked) {
            this.isAgree = true;
        }
        else
            this.isAgree = false;
    }
    
    submit() {
        this.params = {
            isSubmit: true,
            isDirectMarketing: this.declarationCheckboxController.find(x => x.checkbox == "isDirectMarketing").checked
        };

        return this.params;
    }

    get insurerFullName(): string {
        if (this.data.selectedQuotation && this.data.selectedQuotation.code) {
            return INSURER_FULL_NAME[this.data.selectedQuotation.code];
        }

        return "";
    }

    get insurerDeclarationDoc() {
        return this.motorProductDoc;
    }

    private loadInsurerDeclarationList() {
        if (this.data.selectedQuotation.code == INSURER_CODE.Generali) {
            this.declarationList = [
                "common.generaliAcknowledgementOne",
                "common.generaliAcknowledgementTwo",
                "common.generaliAcknowledgementThree"
            ];
        }
        else if (this.data.selectedQuotation.code == INSURER_CODE.Zurich) {
            this.declarationList = [
                "common.zurichAcknowledgement"
            ];
        }
        else if (this.data.selectedQuotation.code == INSURER_CODE.Zurich_Takaful) {
            this.isShowTreatmentOfSmallAmount = true;
            this.treatmentOfSmallAmountTitle = "common.zurichTakafulTreatmentOfSmallAmount";
            this.treatmentOfSmallAmountDesc = "common.zurichTakafulTreatmentOfSmallAmountDesc";

            this.declarationList = [
                "common.zurichTakafulAcknowledgement"
            ];
        }
        else if (this.data.selectedQuotation.code == INSURER_CODE.Ikhlas) {
            this.declarationList = [
                "common.ikhlasAcknowledgement"
            ];
        }
    }
}
